import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Command, CommandService, ProcessSelectors, StateWithProcess, UserIdService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CustomOccTicketsAdapter } from '../adapter/custom-tickets.adapter';
import { Ticket, TicketWrapper } from '../model/ticket.model';
import { LoadTickets, LoadTicketsCategory, LoadTicketsCompanyCategory } from '../store/actions/custom-ticket.action';
import { StateWithTickets, TICKETS_FEATURE } from '../store/custom-tickets-state';
import { getTicketsLoading } from '../store/selectors/custom-tickets.selectors';
import { getTicketstListState } from '../store/selectors/feature-selector';

@Injectable({
  providedIn: 'root'
})
export class CustomTicketsService {
  userId: string = '';
  protected addTicketCommand: Command<{ ticket: Ticket }, Ticket>;

  constructor(
    protected ticketProcessStore: Store<StateWithProcess<void>>,
    protected ticketStateStore: Store<StateWithTickets>,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userIdService: UserIdService,
    protected command: CommandService,
    protected customOccTicketsAdapter: CustomOccTicketsAdapter
  ) {
    this.getUserID();
    this.addTicketCommand = this.command.create(({ ticket }) => {
      return this.customOccTicketsAdapter.addTicket(ticket, this.userId);
    });
  }

  getUserID(): void {
    this.userIdService
      .takeUserId()
      .subscribe((userID) => (this.userId = userID))
      .unsubscribe();
  }

  getTicketListLoading(): Observable<boolean> {
    return this.ticketProcessStore.pipe(select(ProcessSelectors.getProcessLoadingFactory(TICKETS_FEATURE)));
  }

  getTicketListState(): Observable<any> {
    return this.ticketProcessStore.pipe(select(ProcessSelectors.getProcessStateFactory(TICKETS_FEATURE)));
  }

  getTicketsLoading(): Observable<boolean> {
    return this.ticketStateStore.pipe(select(getTicketsLoading));
  }

  getTickets(pageSize?: number, currentPage?: number, sort?: string): void {
    this.userIdService.takeUserId().subscribe((userId) => {
      this.ticketStateStore.dispatch(
        new LoadTickets({
          userId,
          pageSize,
          currentPage,
          sort
        })
      );
    });
  }

  getAndLoadTickets(): Observable<TicketWrapper> {
    return this.ticketStateStore.pipe(select(getTicketstListState));
  }

  loadTicketsCategory(): void {
    this.ticketStateStore.dispatch(new LoadTicketsCategory());
  }

  loadTicketsCompanyCategory(): void {
    this.ticketStateStore.dispatch(new LoadTicketsCompanyCategory());
  }

  addTicket(ticket: Ticket): Observable<Ticket> {
    return this.addTicketCommand.execute({ ticket });
  }
}
